import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ResumeFlow } from './resume-context.service';

export interface ResumeQuoteSummary {
  product: string;
  quantity: number;
  quantityUnit: string;
  amount: number;
  dispatchRegion: string;
  dispatchComuna: string;
  deliveryDate: string;
  deliveryWindow?: string;
}

export interface ResumePaymentInitResponse {
  order_buy?: string;
  url: string;
  token?: string;
}

@Injectable({ providedIn: 'root' })
export class ResumeService {
  constructor(private readonly http: HttpClient) {}

  resolve(token: string): Observable<{ flow: ResumeFlow }> {
    return this.http.post<{ flow: ResumeFlow }>(`${environment.apiUrl}resume/resolve/`, { token });
  }

  recover(token: string, flow: ResumeFlow): Observable<ResumeQuoteSummary> {
    const path = flow === 'cemento' ? 'cemento/cotizacion/resume/recover/' : 'cotizacion/resume/recover/';
    return this.http.post<ResumeQuoteSummary>(`${environment.apiUrl}${path}`, { token });
  }

  initPayment(
    token: string,
    provider: 'flow' | 'gnet' | 'mercadopago',
    recaptcha: string,
    accept_terms = true,
  ): Observable<ResumePaymentInitResponse> {
    return this.http.post<ResumePaymentInitResponse>(`${environment.apiUrl}resume/payment/`, {
      token,
      provider,
      recaptcha,
      accept_terms,
    });
  }
}
